import {
  DISPLAY_EARNING_RULE_GLOBAL_LIMIT_PERIOD,
  EARNING_RULE_GLOBAL_LIMIT_TARGET_TYPE,
  EarningRuleGlobalLimitReward
} from "config/CustomEnums";
import { formatNumberWithCommas } from "utils";

const DISPLAY_GLOBAL_LIMIT_REWARD_FIELD = {
  [EarningRuleGlobalLimitReward.POINTS]: 'points',
  [EarningRuleGlobalLimitReward.PROGRESSION_POINTS]: 'progression_points',
  [EarningRuleGlobalLimitReward.COUPONS]: 'coupons',
  [EarningRuleGlobalLimitReward.STAMPS]: 'stamps',
};

const DISPLAY_GLOBAL_LIMIT_REWARD_SUFFIX = {
  [EarningRuleGlobalLimitReward.POINTS]: 'pts',
  [EarningRuleGlobalLimitReward.PROGRESSION_POINTS]: 'pp',
  [EarningRuleGlobalLimitReward.COUPONS]: 'coupons',
  [EarningRuleGlobalLimitReward.STAMPS]: 'stamps',
};

const GLOBAL_LIMIT_TYPE = {
  TRANSACTIONS: "TRANSACTIONS",
  POINTS: "POINTS",
  PROGRESSION_POINTS: "PROGRESSION_POINTS",
  POINTS_AND_PROGRESSION_POINTS: "POINTS_AND_PROGRESSION_POINTS",
  COUPONS: "COUPONS",
  STAMPS: "STAMPS",
}


export const parseReachLimitInfo = (reachLimitInfo, allReachLimitInfo, rewardType) => {
  if (!reachLimitInfo) {
    return {};
  };

  const parsedReachLimitInfo = JSON.parse(reachLimitInfo) || {};
  const parsedAllReachLimitInfo = JSON.parse(allReachLimitInfo) || [];

  const rewardLimitList = [];
  const transactionLimitList = [];

  // v1.7.0 have all reach limit info
  const haveAllReachLimitInfo = parsedAllReachLimitInfo && parsedAllReachLimitInfo?.length;
  if (haveAllReachLimitInfo) {
    // eslint-disable-next-line no-unused-expressions
    parsedAllReachLimitInfo?.map(item => {
      // reward limit
      if (item?.limit_type === rewardType) {
        let displayPeriod = DISPLAY_EARNING_RULE_GLOBAL_LIMIT_PERIOD?.[item?.period];
        let customDisplayPeriod = null;
        if (item?.target === EARNING_RULE_GLOBAL_LIMIT_TARGET_TYPE.perTransaction) {
          displayPeriod = "Per transaction";
        } else if (item?.target === EARNING_RULE_GLOBAL_LIMIT_TARGET_TYPE.stampCampaignMaxQtySlot) {
          customDisplayPeriod = "Stamp campaign max quantity slot"
        }
        rewardLimitList.push({
          displayPeriod,
          customDisplayPeriod,
          displayLimit: item?.limit,
          displayAccumulated: item?.earned
        })
      };
      // transaction value limit
      if (item?.limit_type === GLOBAL_LIMIT_TYPE.TRANSACTIONS) {
        transactionLimitList.push({
          displayPeriod: DISPLAY_EARNING_RULE_GLOBAL_LIMIT_PERIOD?.[item?.period],
          receiptSource: item?.receiptSource,
          displayLimit: item?.limit,
          displayAccumulated: item?.earned
        })
      }
    })
  };

  const rewardField = DISPLAY_GLOBAL_LIMIT_REWARD_FIELD?.[rewardType];
  const periodField = `${rewardField}_reach_limit_period`;
  const targetField = `${rewardField}_reach_limit_target`;
  const limitValueField = `${rewardField}_limit_value`;
  const totalEarnedField = `${rewardField}_total_earned`;
  const originalRewardField = `${rewardField}_value`;
  const finalRewardField = `${rewardField}_value_after_limit`

  // get rewardLimitList and transactionLimitList from parsedReachLimitInfo
  const limitInfoType = parsedReachLimitInfo?.limit_info_type;
  if (!haveAllReachLimitInfo && limitInfoType) {
    // reward limit
    if (
      limitInfoType === rewardType
      || limitInfoType === GLOBAL_LIMIT_TYPE.POINTS_AND_PROGRESSION_POINTS
    ) {
      const target = parsedReachLimitInfo?.[targetField];
      const period = parsedReachLimitInfo?.[periodField];
      let displayPeriod = DISPLAY_EARNING_RULE_GLOBAL_LIMIT_PERIOD?.[period];
      let customDisplayPeriod = null;
      if (target === EARNING_RULE_GLOBAL_LIMIT_TARGET_TYPE.perTransaction) {
        displayPeriod = "Per transaction";
      } else if (target === EARNING_RULE_GLOBAL_LIMIT_TARGET_TYPE.stampCampaignMaxQtySlot) {
        customDisplayPeriod = "Stamp campaign max quantity slot"
      }

      rewardLimitList.push({
        displayPeriod,
        customDisplayPeriod,
        displayLimit: parsedReachLimitInfo?.[limitValueField],
        displayAccumulated: parsedReachLimitInfo?.[totalEarnedField],
      })
    }
    // transaction value limit
    if (limitInfoType === GLOBAL_LIMIT_TYPE.TRANSACTIONS) {
      const period = parsedReachLimitInfo?.transactions_reach_limit_period;

      transactionLimitList.push({
        displayPeriod: DISPLAY_EARNING_RULE_GLOBAL_LIMIT_PERIOD?.[period],
        receiptSource: null,
        displayLimit: parsedReachLimitInfo?.transactions_limit_value,
        displayAccumulated: parsedReachLimitInfo?.transactions_value_after_limit
      })
    }
  }

  return {
    rewardLimitList,
    transactionLimitList,
    reachLimit: rewardLimitList.length > 0 || transactionLimitList.length > 0,
    showTransactionValue: transactionLimitList.length > 0,
    originalTransactionValue: `$${formatNumberWithCommas(parsedReachLimitInfo?.transactions_value) || '-'
      }`,
    displayOriginalReward: `${formatNumberWithCommas(parsedReachLimitInfo?.[originalRewardField]) || '-'
      } ${DISPLAY_GLOBAL_LIMIT_REWARD_SUFFIX?.[rewardType]
      }`,
    displayFinalReward: `${formatNumberWithCommas(parsedReachLimitInfo?.[finalRewardField]) || '-'
      } ${DISPLAY_GLOBAL_LIMIT_REWARD_SUFFIX?.[rewardType]
      }`,
  }
};
